// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__Yg286","tabs":"styles_tabs__Vf7Su","tab":"styles_tab__cxD4n","selectedTab":"styles_selectedTab__Oe1O7"};